import { VContainer } from 'vuetify/lib/components/VGrid';
import { VMain } from 'vuetify/lib/components/VMain';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VMain,[_c(VContainer,{staticClass:"fill-height",attrs:{"fluid":""}},[_c('Login')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }